<template>
    <section class="detaild-invoice">
        <invoice-nav />
        <div class="top_section">
            <h1 class="title">
                {{ $t("Invoice") }}#
                {{ shipment.invoice_items[0].invoice.identifier }}
            </h1>
        </div>

        <div id="main-shipment">
            <div class="head">
                <div class="logo">
                    <img src="../assets/images/logo.png" alt />
                </div>
                <div class="b-address">
                    <div class="address-item">
                        <h2>Saudi Arabia:</h2>
                        <div>
                            <p>King's Road Tower</p>
                            <p>Level 26th</p>
                            <p>Jeddah, Saudi Arabia</p>
                            <p>+966 557974722</p>
                        </div>
                    </div>
                    <div class="address-item">
                        <h2>United States:</h2>
                        <div>
                            <p>8135 Uehling Ln</p>
                            <p>Huber Heights, Ohaio 45424</p>
                            <p>United States</p>
                            <p>+1 (248)403-2828</p>
                        </div>
                    </div>
                </div>
                <div class="title">
                    <p class="num">
                        {{ $t("Order ID") }} {{ shipment.identifier }}
                    </p>
                    <p class="detail">
                        {{ $t("Due date") }}
                        <span style="padding: 0 8px; font-weight: bold">
                            {{
                                shipment.invoice_items[0].invoice.due_date
                                    | moment("DD MMM YYYY")
                            }}
                        </span>
                    </p>
                </div>
            </div>
            <div class="body">
                <div class="address_title">
                    <h3>{{ $t("Addresses Information") }}</h3>
                </div>

                <div class="address">
                    <div class="item">
                        <h4 class="name">{{ $t("Shipper") }}:</h4>
                        <div class="info">
                            <div>
                                <p class="name">
                                    {{ shipment.origin.full_name }}
                                </p>
                                <p>{{ shipment.origin.address_one }}</p>
                                <p>{{ shipment.origin.state }}</p>
                                <p>
                                    {{ shipment.origin.city }},
                                    {{ shipment.origin.postal_code }}
                                </p>

                                <p>{{ shipment.origin.country.nice_name }}</p>
                            </div>
                            <div>
                                <p>{{ shipment.origin.mobile }}</p>
                                <p>{{ shipment.origin.email }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <h4 class="name">{{ $t("Recipient") }}:</h4>
                        <div class="info">
                            <div>
                                <p class="name">
                                    {{ shipment.destination.full_name }}
                                </p>
                                <p>{{ shipment.destination.address_one }}</p>
                                <p>{{ shipment.destination.state }}</p>
                                <p>
                                    {{ shipment.destination.city }},
                                    {{ shipment.destination.postal_code }}
                                </p>
                                <p>
                                    {{ shipment.destination.country.nice_name }}
                                </p>
                            </div>
                            <div>
                                <p>{{ shipment.destination.mobile }}</p>
                                <p>{{ shipment.destination.email }}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="shipment-info">
                    <div class="info-head">
                        <p class="info-title">
                            {{ $t("Weight") }}
                        </p>
                        <p class="info-q" v-if="shipment.re_weighted">
                            <span class="n">
                                {{
                                    shipment.re_weighted.final_weight
                                        | number("0,0.0")
                                }}
                            </span>
                            <span class="c">{{ $t("KG") }}</span>
                        </p>
                        <p class="info-q" v-if="!shipment.re_weighted">
                            <span class="n">
                                {{ shipment.total_weight | number("0,0.0") }}
                            </span>
                            <span class="c">{{ $t("KG") }}</span>
                        </p>
                    </div>
                    <div class="info-body">
                        <div class="item">
                            <p class="item-title">
                                {{ $t("NO. of packages") }}
                            </p>
                            <p class="info-q">{{ shipment.packages.length }}</p>
                        </div>
                        <div class="item" v-if="shipment.re_weighted">
                            <p class="item-title">
                                {{ $t("Customer weight") }}
                            </p>
                            <p class="info-q">
                                {{ shipment.re_weighted.user_weight }}
                                {{ $t("KG") }}
                            </p>
                        </div>
                        <div class="item">
                            <p class="item-title">{{ $t("Vendor weight") }}</p>
                            <p class="info-q" v-if="shipment.re_weighted">
                                {{ shipment.re_weighted.final_weight }}
                                {{ $t("KG") }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="shipment-info">
                    <div class="info-head">
                        <p class="info-title">
                            {{ $t("Shipment Cost Details") }}
                        </p>
                        <p class="info-q">
                            <span class="n">
                                {{
                                    shipment.invoice_items.reduce(
                                        (a, b) => a + b.debit,
                                        0
                                    ) | currency("")
                                }}
                            </span>
                            <span class="c">{{ $t("SAR") }}</span>
                        </p>
                    </div>
                    <div class="info-body">
                        <div
                            class="item"
                            v-for="(item, i) in shipment.invoice_items"
                            :key="i"
                        >
                            <p class="item-title">
                                {{
                                    $i18n.locale == "en"
                                        ? item.description
                                        : item.description_ar
                                }}
                            </p>
                            <p class="info-q">
                                {{
                                    item.debit === 0
                                        ? item.credit
                                        : item.debit | currency("")
                                }}
                                <span class="c">{{ $t("SAR") }}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-break-shipment" style="break-after: page"></div>
            <div class="footer">
                <div class="amount">
                    <div class="inv-num">
                        <img
                            class="barcode"
                            style="width: 400px"
                            src="@/assets/images/Barcode.svg"
                            alt
                        />
                        <p>{{ shipment.identifier }}</p>
                    </div>
                    <div class="inv-price">
                        <p class="inv-t">{{ $t("Total Shipping Fee") }}</p>
                        <p class="inv-p">
                            <span class="n">
                                {{
                                    shipment.invoice_items.reduce(
                                        (a, b) => a + b.debit,
                                        0
                                    ) | currency("")
                                }}
                            </span>
                            <span class="c">{{ $t("SAR") }}</span>
                        </p>
                        <!-- <button class="button">{{ $t("Make Payment") }}</button> -->
                    </div>
                </div>
                <div class="link">
                    <h2>www.ALKOON.com</h2>
                </div>
            </div>
        </div>

        <div class="options">
            <button class="button">
                {{ $t("Contact ALKOON customer service") }}
            </button>
            <button class="button" v-print="printOptions">
                {{ $t("Print invoice") }}
            </button>
        </div>
    </section>
</template>

<script>
import invoiceNav from "@/components/Nav/invoiceNav.vue";

export default {
    components: {
        invoiceNav,
    },
    data() {
        return {
            printOptions: {
                id: "main-shipment",
                popTitle: "good print",
                extraCss: "https://www.google.com,https://www.google.com",
                extraHead:
                    '<meta http-equiv="Content-Language"content="zh-cn"/>',
            },
        };
    },
    computed: {
        shipment() {
            return this.$store.getters.shipment_details;
        },
    },
    created() {
        this.$store.dispatch("SHIPMENT_DETAILS", {
            service: "shipmentInvoiceDetails",
            reqPayload: this.$route.params.id,
        });
    },
};
</script>

<style lang="scss">
.link {
    text-align: right;

    h2 {
        margin: 0;
        font-size: 20px;
        opacity: 0.7;
    }
}

.b-address {
    display: flex;
    align-items: flex-end;
    direction: ltr;

    .address-item {
        margin: 0 30px;

        h2 {
            font-size: 20px;
            font-weight: bold;
            opacity: 0.9;
        }

        p {
            font-size: 15px;
        }
    }
}

.detaild-invoice {
    background: #efefef80;
    padding: 0 100px;
    margin-top: -120px;

    .page-break-shipment {
        display: none;
    }

    .top_section {
        margin-bottom: 0px;

        .title {
            font-size: 2.2rem;
            font-weight: lighter;
        }
    }

    #main {
        width: 1000px;
    }

    #main-shipment {
        background-image: url("../assets/images/paper_bg.png");
        background-size: cover;
        padding: 30px 50px 0;
        margin-bottom: 10px;
        border-radius: 0 0 10px 10px;
        width: 1000px;
        margin: auto;

        .position-relative {
            position: relative;
        }

        .currency {
            position: absolute;
            bottom: 5px;
            width: 100px;
            font-size: 10px;
            padding: 0 5px;
        }

        .head {
            border-bottom: 1px solid #ddd;
            padding: 30px 30px;

            .logo {
                display: flex;
                flex-flow: row-reverse;
                margin: 35px 7px;
                opacity: 0.5;

                img {
                    width: 200px;
                }
            }

            .title {
                p {
                    &.detail {
                        font-size: 15px;
                        font-weight: bold;
                        background: #ddd;
                        display: inline-block;
                        padding: 5px 30px;
                        border-radius: 50px;
                    }
                }
            }
        }

        .body {
            padding: 10px 70px;

            .address_title {
                h3 {
                    font-weight: bold !important;
                }

                padding-top: 15px;
                border-bottom: 1px solid #ddd;
                font-size: 1.5rem;
            }

            .address {
                display: flex;

                .item {
                    width: 50%;
                }

                .name {
                    font-size: 25px;
                    font-weight: bold;
                    margin: 15px 0;
                }

                .info {
                    margin-top: 10px;

                    div {
                        margin-bottom: 15px;

                        p {
                            font-size: 15px;
                            color: #777;

                            &.name {
                                font-weight: bold;
                                color: #555;
                                margin-bottom: 0;
                            }
                        }
                    }
                }
            }

            .shipment-info {
                margin-top: 50px;

                .info-head {
                    border-bottom: 1px solid #ddd;
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-end;

                    .info-title {
                        font-size: 20px;
                        font-weight: bold;
                    }

                    .info-q {
                        .n {
                            font-size: 3.2rem;
                            font-weight: bold;
                        }

                        .c {
                            font-size: 20px;
                            font-weight: bold;
                        }
                    }
                }

                .info-body {
                    padding: 10px;

                    .item {
                        display: flex;
                        padding: 5px 0 0;

                        p {
                            font-size: 15px;
                            color: #777;

                            &.item-title {
                                width: 78%;
                            }

                            .c {
                                font-size: 10px;
                                font-weight: bold;
                                margin: 0 10px;
                            }
                        }
                    }
                }
            }
        }

        .footer {
            margin-top: 60px;
            background: none;
            border-top: 1px solid #ddd;

            .pill {
                padding: 0 70px;

                div {
                    display: flex;
                    justify-content: space-between;

                    p {
                        font-weight: bold;
                        font-size: 20px;
                    }
                }
            }

            .amount {
                margin-top: 80px;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .inv-num {
                    width: 70%;
                    text-align: center;

                    p {
                        letter-spacing: 13px;
                        font-size: 15px;
                        color: #777;
                    }
                }

                .inv-price {
                    width: 30%;
                    text-align: center;

                    .inv-t {
                        font-size: 20px;
                        font-weight: bold;
                        color: #777;
                    }

                    .inv-p {
                        font-weight: bold;

                        span {
                            &.n {
                                padding: 0 5px;
                                font-size: 40px;
                            }

                            &.c {
                                font-size: 20px;
                            }
                        }
                    }

                    .button {
                        width: 95%;
                        background: none;
                        color: black;
                        height: 30px;
                        font-size: 14px;
                        border-color: #777 !important;
                    }
                }
            }
        }
    }

    .options {
        text-align: right;

        .button {
            margin: 0 15px 40px;
            background: none;
            color: black;
            height: 30px;
            font-size: 14px;
            border-color: #777 !important;
        }
    }
}

@page {
    size: A4;
    margin: 20px 0;
    -webkit-print-color-adjust: exact;
}

@media print {
    .page-break-shipment {
        display: block;
        clear: both;
        page-break-before: always;
    }

    body {
        margin: 0;
        padding: 0;
    }

    .b-address {
        .address-item {
            margin: 0 30px;

            h2 {
                font-size: 16px;
                font-weight: bold;
                opacity: 0.9;
            }

            p {
                font-size: 14px;
            }
        }
    }

    #main-shipment {
        -webkit-print-color-adjust: exact;

        .head {
            border-bottom: 1px solid #ddd;
            padding: 10px 20px;

            .logo {
                display: flex;
                flex-flow: row-reverse;
                margin: 15px 7px;
                opacity: 0.5;

                img {
                    width: 100px;
                }
            }

            .title {
                p {
                    padding: 5px 10px;

                    &.num {
                        font-size: 20px;
                        margin-bottom: 0;
                    }

                    &.detail {
                        font-weight: bold;
                        background: #ddd;
                        display: inline-block;
                        padding: 5px 20px;
                        margin: 0 10px;
                        border-radius: 50px;
                        opacity: 0.9;
                        font-size: 14px;
                    }
                }
            }
        }

        .body {
            padding: 5px 40px;

            .address_title {
                border-bottom: 1px solid #ddd;
                padding: 10px 5px 0;
                margin: 0 -2px;
                font-size: 18px;
                display: inline-block;
            }

            .address {
                display: flex;

                .item {
                    width: 50%;
                }

                .name {
                    font-size: 20px;
                    font-weight: bold;
                    margin: 10px 0;
                }

                .info {
                    margin-top: 10px;

                    div {
                        margin-bottom: 15px;

                        p {
                            font-size: 14px;
                            color: #777;

                            &.name {
                                color: #333;
                                margin-bottom: 0;
                            }
                        }
                    }
                }
            }

            .shipment-info {
                margin-top: 20px;

                .info-head {
                    border-bottom: 1px solid #ddd;
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-end;

                    .info-title {
                        font-size: 20px;
                        font-weight: bold;
                    }

                    .info-q {
                        .n {
                            font-size: 24px;
                            font-weight: bold;
                        }

                        .c {
                            font-size: 15px;
                            font-weight: bold;
                        }
                    }
                }

                .info-body {
                    padding: 10px;

                    .item {
                        display: flex;
                        padding: 5px 0 0;

                        p {
                            font-size: 16px;
                            color: #777;

                            &.item-title {
                                width: 78%;
                            }

                            .c {
                                font-size: 10px;
                                font-weight: bold;
                            }
                        }
                    }
                }
            }
        }

        .footer {
            border-top: none;
            margin-top: 30px;
            padding-top: 30px;

            .pill {
                padding: 0 30px;

                div {
                    display: flex;
                    justify-content: space-between;

                    p {
                        font-size: 20px;
                        font-weight: 500;
                        color: #333;
                    }
                }
            }

            .amount {
                margin-top: 40px;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .inv-num {
                    width: 60%;
                    text-align: center;

                    .barcode {
                        width: 350px !important;
                        opacity: 0.4;
                    }

                    p {
                        letter-spacing: 13px;
                        font-size: 16px !important;
                        color: #777;
                    }
                }

                .inv-price {
                    width: 40%;
                    text-align: center;

                    .inv-t {
                        font-size: 16px;
                        font-weight: bold;
                        color: #777;
                    }

                    .inv-p {
                        font-weight: bold;

                        span {
                            &.n {
                                padding: 0 5px;
                                font-size: 24px;
                            }

                            &.c {
                                font-size: 10px;
                            }
                        }
                    }

                    .button {
                        display: none;
                    }
                }
            }
        }
    }
}
</style>
